import { fetchProfileTariff, closeTariff } from '../../../services/api/tariff';

export const profileTariff = {
    namespaced: true,
    state: {
        // isFetched: false,
        tariff: {},
    },
    mutations: {
        save(state, data) {
            state.tariff = data;
        },
        resetState(state) {
            state.tariff = {};
        }
    },
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        fetchProfileTariff({ commit, dispatch }) {
            return fetchProfileTariff()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        closeTariff({ commit, dispatch }) {
            return closeTariff()
                .then((res) => {
                    commit('save', {});

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    if (res.status === 400) {
                        throw {
                            ...res,
                            message: res.data.message,
                        };
                    }

                    throw res;
                });
        }
    },
    getters: {
        tariff({ tariff }) {
            return tariff;
        },
        balance({ tariff }) {
            return (tariff && tariff.balance) || 0;
        },
        isFetched({ tariff }) {
            return tariff && !!Object.keys(tariff).length;
        },
        profileTariffId({ tariff }) {
            return (tariff && tariff.packageId) || null;
        }
    },
};



// WEBPACK FOOTER //
// ./src/modules/home/profileTariff/store.js